module.exports = __webpack_public_path__ + "img/block_2_img.76d3cc1d.png";